var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVortexRealEstates01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 438 416",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#09B2C9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M375.3,96.45a10.2,10.2,0,0,1-10.2,10.19H324.32v15.3h-20.4v-15.3H202v15.3h-20.4v-15.3H120.38V351.37H89.79V71a5.1,5.1,0,0,1,5.1-5.1h20.39a5.1,5.1,0,0,1,5.1,5.1V86.25H365.1A10.2,10.2,0,0,1,375.3,96.45Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M324.32,137.24H140.78a10.19,10.19,0,0,0-10.2,10.19V280a10.2,10.2,0,0,0,10.2,10.2H324.32A10.2,10.2,0,0,0,334.51,280V147.43A10.19,10.19,0,0,0,324.32,137.24ZM292,217.64a10.2,10.2,0,0,1-14.14,2.83l-4.5-3V259.6H247.84V223.91a5.1,5.1,0,0,0-5.1-5.1H222.35a5.1,5.1,0,0,0-5.1,5.1V259.6H191.76V217.47l-4.54,3a10.2,10.2,0,0,1-11.31-17l51-34a10.21,10.21,0,0,1,11.31,0l50.95,34A10.18,10.18,0,0,1,292,217.64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVortexRealEstates01);
export default __webpack_public_path__ + "static/media/Vortex_Real-Estates-01.7bff8eb3fb0440b7bc62577c059d6eab.svg";
export { ForwardRef as ReactComponent };